//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectField from '@/components/d0822/fields/selectField.vue';
import RegisterButton from './registerButton.vue';
import MobileStreamViewButton from './mobileStreamViewButton.vue';

import SwiperMixin from '@/mixins/swiper.mixin.js';
import viewportMixin from '@/mixins/viewport.mixin';

export default {
  components: {
    SelectField,
    RegisterButton,
    MobileStreamViewButton,
  },
  mixins: [SwiperMixin, viewportMixin],
  data() {
    return {
      selectOptions: [],
    };
  },
  computed: {
    topicStatus() {
      return this.$store.getters['event/topicStatus'];
    },
    eventStatus() {
      return this.$store.state.event.eventStatus;
    },
    event() {
      return this.$store.state.event.data;
    },
    topicIndex: {
      get() {
        return this.topic.num;
      },
      set(num) {
        this.$store.commit('event/SELECT_TOPIC_BY_NUM', num);
        if (this.swiper) {
          this.swiper.slideTo(num);
        }
      },
    },
    topic() {
      return this.$store.state.event.topic;
    },
    activeTopic() {
      return this.event?.activeTopic?.num;
    },
    selectorMode() {
      return this.event.topics.length > 3;
    },
    count() {
      return this.event.topics.length;
    },
    isSubscribed() {
      return this.$store.state.event.isSubscribed;
    },
    closeRegistration() {
      return this.$store.state.event.closeRegistration;
    },
  },
  watch: {
    // Если экран уменьшается до мобильного и свайпер ещё не создан
    // Создать его
    isMobile(payload) {
      if (!this.swiper && payload) this.initSwiper();
    },
  },
  created() {
    this.slidesPerView = 'auto';
    // В функции создаётся список топиков для селектора в нужном формате
    this.selectOptions = this.createOptions();
  },
  mounted() {
    if (this.selectorMode && this.isMobile) {
      this.$nextTick(() => {
        this.initSwiper();
        this.swiper?.slideTo(this.topicIndex);
      });
    }
  },
  methods: {
    /** Все топики, которые идут после активного - недоступны
     *  Активный топик - это не выбранный в селекторе, а
     *  последний доступный. Он указывается на сервере для ивента
     */
    createOptions() {
      return this.event.topics.map((i) => ({
        disabled: i.num > this.activeTopic,
        text: `${this.$t('eventos.topics.day')} ${i.num + 1}`,
        value: i.num,
      }));
    },
  },
};
